import React, { useState, forwardRef, useEffect } from 'react';
import { Modal, Dropdown } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';

const InviteCustomer = forwardRef((props, ref) => {
  const [inviteModal, setInviteModal] = useState(true);
  const [TypeName, setTypeName] = useState('');
  const [selectedAccount, setSelectedAccount] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [data, setData] = useState([]);
  const [recordsState, setRecordsState] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 8;

  const navigate = useNavigate();
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);

  const pageName = 'ExpenseTypes';
  const actionsForPage = getActionsForPage(pageName);

  const userdata1 = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata1);
  const userid = userData.id;

  function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    if (pagePermissions) return pagePermissions.action;
    navigate('/dashboard_1');
    return [];
  }

  // ================= API Calls =================

  const getCities = () => {
    axios.get('https://subk.education.com.ly/back/api/expense_types')
      .then(res => {
        setData(res.data);
       })
      .catch(err => console.error(err));
  }

  const getAccounts = () => {
    axios.get("https://subk.education.com.ly/back/api/accountsexpenses")
      .then(res => {
        if (res.data.success) setAccounts(res.data.accounts);
      })
      .catch(err => console.error(err));
  }

  // ================= Pagination =================
   

  // ================= Modal =================
  const showInviteModal = () => {
    setInviteModal(false);
    navigate('/Dashboard_1');
  }

  // ================= Create ExpenseType =================
  const createEmployee = async (e) => {
    e.preventDefault();
    if (!selectedAccount) return swal("خطأ", "الرجاء اختيار الحساب", "warning");

    const formData = {
      TypeName:TypeName,
      AccountID: selectedAccount,
      UserID: userid,
      status: "متوفر"
    };

    try {
      const res = await axios.post('https://subk.education.com.ly/back/api/expense_types', formData);
      if (res.data.status === 200) swal("تم بنجاح", res.data.message, "success");
      setTypeName('');
      setSelectedAccount('');
      getCities(); // تحديث الجدول بعد الإضافة
    } catch (err) {
      console.error(err);
      swal("خطأ", "حدث خطأ أثناء إضافة البند", "error");
    }
  }

  // ================= Edit Record =================
  const handleEdit = (ExpenseTypeID, field, value) => {
    const updatedRecords = data.map((r) =>
      r.ExpenseTypeID === ExpenseTypeID ? { ...r, [field]: value } : r
    );
    setData(updatedRecords);

    axios.put(`https://subk.education.com.ly/back/api/expense_types/${ExpenseTypeID}`, { [field]: value })
      .then(res => console.log("Updated successfully"))
      .catch(err => console.error(err));
  }

  // ================= Dropdown Status =================
  const handleAction = (id, field, value) => {
    handleEdit(id, field, value);
  }

  useEffect(() => {
    getAccounts();
    getCities();
  }, []);

  
  // ================= Render =================
  return (
    <Modal className="modal fade" show={inviteModal} centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5">أسماء البنود لنفقات الشركة</h1>
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>showInviteModal()}></button>
        </div>
        <div className="modal-body py-2 px-3">
          <form onSubmit={createEmployee}>
            <div className="row">
              <div className="col-xl-4">
                <label className="form-label mt-3">البند</label>
                <input
                  type="text"
                  required
                  className="form-control mt-1"
                  value={TypeName}
                  onChange={(e) => setTypeName(e.target.value)}
                />
              </div>

              <div className="col-xl-6">
                <label className="form-label mt-3">الحساب</label>
                <select
                  className="form-control mt-1"
                  value={selectedAccount || ""}
                  onChange={(e) => setSelectedAccount(e.target.value)}
                  required
                >
                  <option value="">-- اختر حساب المصروف --</option>
                  {accounts.map((acc) => (
                    <option key={acc.AccountID} value={acc.AccountID}>
                      {acc.AccountName}
                    </option>
                  ))}
                </select>
              </div>
            {actionsForPage.includes("create") && (
  <div className="col-xl-2 pe-0" style={{ paddingTop:"0.375rem",marginTop:'40px'}}>
                                              <button  id="toastr-success-top-left" className="btn btn-primary   me-2 btn-icon-xs">+</button>
                                        </div>            )}            </div>

          </form>
<div className="table-responsive active-projects task-table my-2 mx-2" style={{  height: "400px" }}>
                                     
             <table className="table">
              <thead style={{ position: "sticky", top: 0, zIndex: 1 ,backgroundColor:'white'}}>
                <tr>
                  <th scope="col">اسم البند</th>
                  <th scope="col">الحساب</th>
                  {/* <th scope="col">الحالة</th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((row, key) => (
                  <tr key={key}>
                    {/* Editable TypeName */}
                    <td
                      contentEditable={actionsForPage.includes("edit")}
                      suppressContentEditableWarning
                      onBlur={(e) =>
                        handleEdit(row.ExpenseTypeID, "TypeName", e.target.textContent)
                      }
                    >
                      {row.TypeName}
                    </td>

                    {/* Editable Account */}
                    <td>
                      {actionsForPage.includes("edit") ? (
                        <select
                          className="form-control"
                          value={row.AccountID || ""}
                          onChange={(e) =>
                            handleEdit(row.ExpenseTypeID, "AccountID", e.target.value)
                          }
                        >
                          <option value="">-- اختر الحساب --</option>
                          {accounts.map((acc) => (
                            <option key={acc.AccountID} value={acc.AccountID}>
                              {acc.AccountName}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span>
                          {accounts.find((a) => a.AccountID === row.AccountID)?.AccountName || ""}
                        </span>
                      )}
                    </td>

                    {/* Status Dropdown */}
                    {/* <td>
                      {actionsForPage.includes("edit") ? (
                        <Dropdown
                          onSelect={(eventKey) =>
                            handleAction(row.ExpenseTypeID, "status", eventKey)
                          }
                        >
                          <Dropdown.Toggle
                            id="statusDropdown"
                            as="div"
                            className={row.status === "متوفر" ? "Complete" : "Pending"}
                          >
                            {row.status || "اختر الحالة"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item eventKey="متوفر">متوفر</Dropdown.Item>
                            <Dropdown.Item eventKey="غير متوفر">غير متوفر</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : (
                        <span>{row.status}</span>
                      )}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default InviteCustomer;
